import { render, staticRenderFns } from "./UsersHistory.vue?vue&type=template&id=a7fdb60a"
import script from "@/scripts/users/usersHistory.js?vue&type=script&lang=js&external"
export * from "@/scripts/users/usersHistory.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports